import React, { useState, useEffect } from "react";
import { Link, CommonAuthButton, SliderWrapper, EmailInput } from "../index";
import { NEW_ONBOARDING_ROUTES } from "../constants/routes.constants";
import styles from "./ForgotPassword.module.css";
import { Auth } from "../../../config/aws-exports";
import { useDispatch, useSelector } from "react-redux";
import { fetchExistingtUser } from "../../../redux/actions";
import { validateEmail } from "../utils/passwordUtils";
import { useHistory } from "react-router-dom";
import { message } from "antd";

const EXTERNAL_SIGNUP = "PreSignUp_ExternalProvider";

export const ForgotPassword = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const [email, setEmail] = useState("");
  const [submittedEmail, setSubmittedEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const userExist = useSelector(
    (state) => state.chekckUserReducer.user.userExist
  );

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!email) {
      message.error("Email is required");
      return;
    }

    if (!validateEmail(email)) {
      message.error("Please enter valid email address");
      return;
    }

    const lowerEmail = email.toLowerCase();
    setLoading(true);
    setSubmittedEmail(lowerEmail);
    dispatch(fetchExistingtUser(lowerEmail));
  };

  useEffect(() => {
    if (!submittedEmail || !userExist) return;

    if (
      userExist.valid &&
      userExist.cognitoTriggerSource !== EXTERNAL_SIGNUP
    ) {
      Auth.forgotPassword(submittedEmail)
        .then(() => {
          history.push(NEW_ONBOARDING_ROUTES.RESET_PASSWORD, {
            email: submittedEmail,
          });
        })
        .catch((err) => {
          message.error(err.message || "Something went wrong");
          setLoading(false);
          setSubmittedEmail("");
        });
    } else {
      setLoading(false);
      setSubmittedEmail("");

      if (userExist.cognitoTriggerSource === EXTERNAL_SIGNUP) {
        message.error("OOPS, can’t reset password for social login");
      } else {
        message.error("No account found with this email address.");
      }
    }
  }, [userExist]);

  return (
    <SliderWrapper>
      <div className={styles.formCard}>
        <h2 className={styles.title}>Forgot Password?</h2>

        <p className={styles.subTitle}>
          Enter your email address and we’ll send you a verification code to reset your password.
        </p>

        <form className={styles.form} onSubmit={handleSubmit}>
          <EmailInput
            label="Work Email"
            value={email}
            handleChange={handleChange}
          />

          <CommonAuthButton
            type="submit"
            label="Send Code"
            className={styles.submitBtn}
            loading={loading}
          />

          <p className={styles.bottomText}>
            Remember Password?{" "}
            <Link to={NEW_ONBOARDING_ROUTES.LOGIN}>Log in</Link>
          </p>
        </form>
      </div>
    </SliderWrapper>
  );
};